import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  iconWrapper: {
    display: 'block',
    lineHeight: 0,
    '& img': {
      width: 120,
      height: 'auto',
      objectFit: 'contain',
    },
  },
  item: {
    maxWidth: 150,
  },
}));
